import { useEffect } from 'react'

export const enum EVENTS {
  ACCOUNT_TOKEN_UPDATE = '@ch:account-access-token-update',
  LOGOUT = '@ch:logout',
  PROFILE_CHANGE = '@ch:profile-change',
}

interface EventTypes {
  [EVENTS.ACCOUNT_TOKEN_UPDATE]: string
  [EVENTS.LOGOUT]: string
}

export type WindowEventMap = {
  [K in keyof EventTypes]: CustomEvent<EventTypes[K]> | Event
}

export function addCustomEventListener<T extends keyof WindowEventMap>(
  listenOn: T,
  callback: (event: WindowEventMap[T]) => void,
) {
  if (typeof window === 'undefined') return
  window.addEventListener(listenOn, callback)
}

export function removeCustomEventListener<T extends keyof WindowEventMap>(
  listenOn: T,
  callback: (event: WindowEventMap[T]) => void,
) {
  window.removeEventListener(listenOn, callback)
}

export function dispatchCustomEvent<T extends keyof EventTypes>(
  event: T,
  detail?: EventTypes[T],
) {
  window.dispatchEvent(new CustomEvent(event, { detail }))
}

export function useCustomEventListener<T extends keyof WindowEventMap>(
  listenOn: T,
  callback: (event: WindowEventMap[T]) => void,
) {
  useEffect(() => {
    window.addEventListener(listenOn, callback)

    return () => window.removeEventListener(listenOn, callback)
  }, [callback, listenOn])
}
